import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { FaEye, FaEyeSlash } from "react-icons/fa";

import { signup } from "../../../redux/slices/authSlice";
import {
  Container,
  FormContainer,
  FormGroup,
  ImgSection,
} from "./SignupStyles";
import logo from "../../../assets/images/headerLogo.svg";
import btnlogo from "../../../assets/images/btnLogo.svg";

const Signup = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loading } = useSelector((state) => state.auth);

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const toggleType = () => {
    setShowPassword(!showPassword);
  };
  const toggleType2 = () => {
    setShowConfirmPassword(!showConfirmPassword);
  };

  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    password: "",
    skype: "",
    companyName: "",
    location: "",
  });

  const [errors, setErrors] = useState({
    password: "",
    confirmPassword: "",
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const validatePassword = () => {
    if (formData.password.length < 8) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        password: "Password must be at least 8 characters long",
      }));
    } else {
      setErrors((prevErrors) => ({
        ...prevErrors,
        password: "",
      }));
    }
  };

  const validateConfirmPassword = () => {
    if (formData.confirmPassword !== formData.password) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        confirmPassword: "Passwords do not match",
      }));
    } else {
      setErrors((prevErrors) => ({
        ...prevErrors,
        confirmPassword: "",
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    validatePassword();
    validateConfirmPassword();

    if (!errors.password && !errors.confirmPassword) {
      const result = await dispatch(signup(formData));
      if (signup.fulfilled.match(result)) {
        navigate(`/verification-notifier/${formData.email}`);
      }
    }
  };

  return (
    <Container>
      <FormContainer>
        <img src={logo} alt="logo" />
        <h1>Sign up</h1>
        <form onSubmit={handleSubmit}>
          <FormGroup>
            <div>
              <label htmlFor="firstName">First Name</label>
              <input
                type="text"
                name="firstName"
                placeholder="First Name"
                value={formData.firstName}
                onChange={handleChange}
              />
            </div>

            <div>
              <label htmlFor="lastName">Last Name</label>
              <input
                type="text"
                name="lastName"
                placeholder="Last Name"
                value={formData.lastName}
                onChange={handleChange}
              />
            </div>

            <div>
              <label htmlFor="email">Email</label>
              <input
                type="email"
                name="email"
                placeholder="Email"
                value={formData.email}
                onChange={handleChange}
              />
            </div>

            <div>
              <label htmlFor="skype">Skype ID</label>
              <input
                type="text"
                name="skype"
                placeholder="Skype ID"
                value={formData.skype}
                onChange={handleChange}
              />
            </div>

            <div>
              <label htmlFor="companyName">Company Name</label>
              <input
                type="text"
                name="companyName"
                placeholder="Company Name"
                value={formData.companyName}
                onChange={handleChange}
              />
            </div>

            <div>
              <label htmlFor="location">Location</label>
              <input
                type="text"
                name="location"
                placeholder="Location"
                value={formData.location}
                onChange={handleChange}
              />
            </div>
          </FormGroup>

          <div className="single-form">
            <label htmlFor="password">Password</label>
            <input
              type={showPassword ? "text" : "password"}
              name="password"
              placeholder="Password"
              value={formData.password}
              onChange={handleChange}
              onBlur={validatePassword}
            />
            {showPassword ? (
              <FaEyeSlash className="eye" onClick={toggleType} />
            ) : (
              <FaEye className="eye" onClick={toggleType} />
            )}
            {errors.password && <p className="error">{errors.password}</p>}
          </div>

          <div className="single-form">
            <label htmlFor="confirmPassword">Confirm password</label>
            <input
              type={showConfirmPassword ? "text" : "password"}
              name="confirmPassword"
              placeholder="Confirm password"
              value={formData.confirmPassword}
              onChange={handleChange}
              onBlur={validateConfirmPassword}
            />
            {showConfirmPassword ? (
              <FaEyeSlash className="eye" onClick={toggleType2} />
            ) : (
              <FaEye className="eye" onClick={toggleType2} />
            )}
            {errors.confirmPassword && (
              <p className="error">{errors.confirmPassword}</p>
            )}
          </div>

          <button type="submit" disabled={loading}>
            {loading ? "Signing up..." : "Sign Up"}
          </button>
        </form>
        <p>
          Already have an account? <a href="/login">Sign in</a>
        </p>
      </FormContainer>

      <ImgSection>
        <div>
          <img src={btnlogo} alt="btn logo" />
          <p>
            Run your ads and campaigns with DigiClick and make huge <br />
            impressions and conversions that will help your business.
          </p>
        </div>
      </ImgSection>
    </Container>
  );
};

export default Signup;
